import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Gift, Copy, Check, Users } from "lucide-react";

export const ReferralCard = () => {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/me/referral").then(({ data }) => setData(data)).catch(() => setData(null));
  }, []);

  const copy = async () => {
    if (!data?.link) return;
    try {
      await navigator.clipboard.writeText(data.link);
      setCopied(true);
      toast.success("Referral link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy — please copy manually.");
    }
  };

  if (!data) return null;

  return (
    <div className="card-soft" data-testid="referral-card">
      <h2 className="font-heading text-xl text-[#1E3F33] mb-2 flex items-center gap-2">
        <Gift className="w-4 h-4 text-[#CC5A3A]" /> Invite &amp; share
      </h2>
      <p className="text-sm text-[#5C6B64] mb-3">Share your personal link — anyone who signs up through it is credited to you.</p>

      <div className="flex items-center gap-2">
        <input
          data-testid="referral-link-input"
          readOnly
          value={data.link}
          onClick={(e) => e.target.select()}
          className="input-soft flex-1 text-sm"
        />
        <button
          type="button"
          data-testid="referral-copy-button"
          onClick={copy}
          className="btn-secondary py-2.5 px-3 inline-flex items-center gap-2 whitespace-nowrap"
        >
          {copied ? <Check className="w-4 h-4 text-[#2D6A4F]" /> : <Copy className="w-4 h-4" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>

      <div className="mt-4 flex items-center gap-2 text-sm text-[#1E3F33]" data-testid="referral-count">
        <Users className="w-4 h-4 text-[#2D6A4F]" />
        <span className="font-semibold">{data.count}</span>
        <span className="text-[#5C6B64]">{data.count === 1 ? "person has" : "people have"} joined via your link</span>
      </div>
    </div>
  );
};
